import React, { useEffect } from "react";
import addUploadIcon from "../../assets/Icons/addUploadIcon.svg";
import addBulkUploadIcon from "../../assets/Icons/addBulkUploadIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";

import AdminAppBar from "../adminComponents/AdminAppBar";
import { toast, ToastContainer } from "react-toastify";
import BackArrows from "../Form/BackArrow/BackArrows";

const LeadUploadPanel = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const userRole = JSON.parse(localStorage?.getItem("userData"))?.user?.role;

    const handleManualClick = () => {
        if (userRole === "Admin") {
            navigate("/admin/lead-upload/manual");
        } else if (userRole === "CMO") {
            navigate("/cmo/lead-upload/manual");
        } else if (userRole === "BOD") {
            navigate("/bod/lead-upload/manual");
        } else if (userRole === "Lead Uploader") {
            navigate("/lead-uploader/lead-upload/manual");
        }
    };

    const handleBulkUploadClick = () => {
        if (userRole === "Admin") {
            navigate("/admin/lead-upload/bulk");
        } else if (userRole === "CMO") {
            navigate("/cmo/lead-upload/bulk");
        } else if (userRole === "BOD") {
            navigate("/bod/lead-upload/bulk");
        } else if (userRole === "Lead Uploader") {
            navigate("/lead-uploader/lead-upload/bulk");
        }
    };

    useEffect(() => {
        if (location.state?.message) {
            toast.success(location.state.message, {
                position: "top-center",
                theme: "light",
                className: "absolute top-20",
            });
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location, navigate]);

    const handleBack = () => {
        if (userRole === "Admin") {
            navigate('/admin/lead-db');
        } else if (userRole === "CMO") {
            navigate('/cmo/lead-db');
        } else if (userRole === "BOD") {
            navigate('/BOD/dashboard');
        } else if (userRole === "Lead Uploader") {
            navigate('/MD/lead-db');
        }
    }

    return (
        <div className="fixed inset-0 flex flex-col bg-appGrayBackground">
            <AdminAppBar />
            <ToastContainer />

            <div className="flex-1 flex flex-col pt-20">
                <div className="container mx-auto flex-1 flex flex-col p-4">
                    <div className="flex items-center gap-4 mb-4">
                        <BackArrows onClick={handleBack} />
                        <h2 className=" md:text-3xl lg:text-3xl   font-semibold 4xl:text-4xl  ">
                        Lead Upload Panel
                        </h2>
                    </div>

                    <div className="">
                    <div className=" grid grid-cols-2 mx-40   xl:h-[380px] xl:mt-10 2xl:h-[400px] lg:mt-3 items-center  shadow-md rounded-lg  h-[500px] bg-white  4xl:h-[580px]  ">
                    <div 
                                className="border-b md:border-b-0 md:border-r border-gray-300 flex items-center justify-center p-8 cursor-pointer"
                                onClick={handleManualClick}
                            >
                                <div className="flex flex-col items-center text-center">
                                    <img className="w-16 h-16 md:w-20 md:h-20" src={addUploadIcon} alt="" />
                                    <span className="text-xl md:text-2xl lg:text-3xl font-semibold mt-2">Manual Add</span>
                                </div>
                            </div>

                            <div 
                                className="flex items-center justify-center p-8 cursor-pointer"
                                onClick={handleBulkUploadClick}
                            >
                                <div className="flex flex-col items-center text-center gap-2">
                                    <img className="w-16 h-16 md:w-20 md:h-20" src={addBulkUploadIcon} alt="" />
                                    <span className="text-xl md:text-2xl lg:text-3xl font-semibold">Bulk Upload</span>
                                    <span className="text-sm md:text-lg">Excel/Google sheet</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="py-4 text-center">
                        <p className="text-base md:text-lg">
                            Note: Lead Uploaded here will be reflected in <br />
                            admin panel as fresh lead
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeadUploadPanel;